import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import MessageComponent from "./components/MessageComponent";
import "./App.css";

import ReactGA from "react-ga4";
ReactGA.initialize("G-KH5THD6DTW");

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MessageComponent />} />
      </Routes>
    </Router>
  );
};

export default App;
